module.exports = __webpack_public_path__ + "img/fortnite.fef37aa3.png";